import { Row as RowAntd } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .hidden {
    display: none;
  }
`;

export const CardSelectedCliente = styled.div`
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  overflow: auto;
  margin-bottom: 10px;

  p {
    margin-bottom: 1px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.85);
  }

  &:hover {
    border-color: #52c41a;
    box-shadow: 0px 0px 0px 2px rgba(36, 169, 93, 0.25);
  }
`;

export const CardLine = styled(RowAntd)`
  padding: 14px 36px 14px 24px;
  .text-bold {
    font-weight: bold;
  }
`;

export const RowCard = styled(RowAntd)`
  overflow: auto;
  max-height: 550px;
`;
